import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/lib/jenkins/workspace/web_teampc_development/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import globalMixin from '@/mixins/globalMixin';
import { getUrlParams } from '@/utils/index.js';
import { dingdingLogin, sendRandPwd, getFirmCorpId, captchaVerifyAsync } from '@/api/login';
export default {
  name: 'Login',
  mixins: [globalMixin],
  data: function data() {
    return {
      corpid: '',
      appId: '',
      ddCode: '',
      activeName: 'qrcodeLogin',
      // 登录方式
      phoneForm: {
        // 随机密码登录
        phoneNum: '',
        code: ''
      },
      phoneNumTip: '',
      canSendYzm: false,
      // 可以发送验证码
      yzmTimer: null,
      // 验证码计时器
      yzmSend: true,
      // '发送验证码'
      count: '',
      // 秒数
      loginToken: '',
      phoneReg: /^1[3-9][0-9]{9}$/,
      loading: false,
      // 登录loading
      captchaLoaded: false,
      captcha: null // 阿里云验证码

    };
  },
  computed: {
    // 登录按钮是否置灰
    loginBtnDisable: function loginBtnDisable() {
      var that = this;
      var isDisable;

      if (that.activeName === 'phoneLogin') {
        isDisable = !(that.phoneForm.phoneNum && that.phoneForm.code) || !that.phoneReg.test(that.phoneForm.phoneNum);
      }

      return isDisable;
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    var _this = this;

    setTimeout(function () {
      _this.destroyCaptchaFn();
    }, 2000);
    next();
  },
  mounted: function mounted() {
    var that = this; // 钉钉登录回跳

    var code = that.$route.query.code || getUrlParams('code');
    var state = that.$route.query.state || getUrlParams('state');

    if (code && state === 'login') {
      that.ddCode = that.$route.query.code;
      dingdingLogin({
        code: that.ddCode
      }).then(function (res) {
        if (parseInt(res.code) === 200) {
          that.$store.dispatch('logindd', res.data).then(function () {
            that.loading = false; // 回到上个页面

            if (localStorage['workOriginUrl'] && localStorage['workOriginUrl'] !== 'undefined' || that.$route.query.originUrl && that.$route.query.originUrl !== 'undefined') {
              window.location.href = localStorage['workOriginUrl'] || that.$route.query.originUrl;
              localStorage.removeItem('workOriginUrl');
            } else {
              that.$router.push({
                path: '/workindex'
              });
            }
          }).catch(function (e) {
            that.loading = false;
          });
        } else {
          that.init();
        }
      }).catch(function () {
        that.init();
      });
    } else {
      localStorage.removeItem('workOriginUrl');
      that.getFirmInfo(function () {
        that.init();
      });
    }

    this.phoneForm.phoneNum = localStorage.getItem('loginPhoneNum') || '';
  },
  methods: {
    getFirmInfo: function () {
      var _getFirmInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(callback) {
        var res, newUserInfo;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getFirmCorpId({
                  corp_code: this.$route.query.corpCode || getUrlParams('corpCode') || ''
                });

              case 2:
                res = _context.sent;

                if (res && res.code === 200 && res.data) {
                  this.corpid = res.data.corp_id;
                  this.appId = res.data.scan_qrcode_app_id;
                  newUserInfo = {
                    corp_id: this.corpid
                  };
                  this.$store.dispatch('updateFirmId', newUserInfo).then(function () {
                    callback && callback();
                  });
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getFirmInfo(_x) {
        return _getFirmInfo.apply(this, arguments);
      }

      return getFirmInfo;
    }(),
    init: function init() {
      var that = this;
      that.ddCode = '';

      if (that.activeName === 'qrcodeLogin') {
        that.getAdminBind();
        that.ddLogin();
      } else {
        that.$nextTick(function () {
          that.$refs.phoneRef.focus();
        });
      }
    },
    // 绑定钉钉
    getAdminBind: function getAdminBind() {
      var that = this;
      var env = process.env.NODE_ENV;

      if (env === 'production') {
        // that.appId = 'dingoa0hal9lwom6yhxer9'
        that.callbackUrl = window.location.protocol + '//team.lezhu.shop/login'; // that.corpid = 'dinga51dd8700552f4fe35c2f4657eb6378f'
      } else {
        // that.appId = 'dingoambplyxgdnqi0lomk'
        that.callbackUrl = window.location.protocol + '//team-dev.lezhu.shop/login'; // that.corpid = 'dinga51dd8700552f4fe35c2f4657eb6378f'
      }
    },
    ddLogin: function ddLogin() {
      var that = this;
      var ding = {
        appid: '',
        agentid: '',
        corpid: '',
        uri: '',
        redirect_uri: '',
        code: '',
        accesstoken: ''
      }; // 1.5.1.设置扫描授权id

      ding.appid = that.appId; // 1.5.2.设置重定向地址

      ding.redirect_uri = that.callbackUrl;
      ding.corpid = that.corpid; // 1.5.3.扫码触发跳转钉钉接口地址

      ding.uri = 'https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=' + ding.appid + '&response_type=code&scope=snsapi_login&state=login&redirect_uri=' + ding.redirect_uri; // eslint-disable-next-line no-unused-vars

      var obj = DDLogin({
        id: 'qrcodeId',
        goto: encodeURIComponent(ding.uri),
        style: 'border: none; background-color: #f0f2f5',
        width: '365',
        height: '400'
      });

      var getcode = function getcode(event) {
        var origin = event.origin;

        if (origin === 'https://login.dingtalk.com') {
          // 判断是否来自ddLogin扫码事件。
          var loginTmpCode = event.data; // 拿到loginTmpCode后就可以在这里构造跳转链接进行跳转了

          ding.code = loginTmpCode;
          window.parent.postMessage(loginTmpCode, '*'); // 1.跳转到主页面，微应用自身截取code比对用户信息

          var redirect_uri_check = ding.uri + '&loginTmpCode=' + loginTmpCode;
          window.location.href = redirect_uri_check; // 回到上个页面

          if (that.$route.query.originUrl && that.$route.query.originUrl !== 'undefined') {
            localStorage['workOriginUrl'] = that.$route.query.originUrl;
          }
        }
      }; // 2.4.钉钉扫码监听


      if (typeof window.addEventListener !== 'undefined') {
        window.addEventListener('message', getcode, false);
      } else if (typeof window.attachEvent !== 'undefined') {
        window.attachEvent('onmessage', getcode);
      }
    },
    // 切换登录方式
    tabClick: function tabClick(val) {
      var that = this;

      if (that.activeName === 'phoneLogin') {
        // 阿里云验证码
        !that.captchaLoaded && that.loadCaptchaFn();
        that.$nextTick(function () {
          that.$refs.phoneRef.focus();
        });
      }
    },
    // 输入手机号失焦
    phoneBlur: function phoneBlur() {
      var that = this;
      var phoneVal = that.phoneForm.phoneNum.trim();

      if (that.phoneReg.test(phoneVal)) {
        that.canSendYzm = true;
        that.phoneNumTip = '';
      } else {
        that.canSendYzm = false;

        if (phoneVal) {
          that.phoneNumTip = '请输入正确的手机号码';
        }
      }
    },
    // 删除手机号-手机号登录
    clearPhoneNum: function clearPhoneNum() {
      this.phoneForm.phoneNum = '';
      this.canSendYzm = false;
      this.phoneNumTip = '';
    },
    // 点击发送验证码
    sendYzm: function sendYzm() {
      this.slideSucces();
    },
    // 开始发送验证码
    slideSucces: function slideSucces() {
      var that = this;
      sendRandPwd({
        mobile: that.phoneForm.phoneNum.trim()
      }).then(function (res) {
        if (res && res.code === 200) {
          that.loginToken = res.data.login_token;
          var TIME_COUNT = 120;

          if (!that.yzmTimer) {
            that.count = TIME_COUNT;
            that.yzmSend = false;
            that.yzmTimer = setInterval(function () {
              if (that.count > 0 && that.count <= TIME_COUNT) {
                that.count--;
              } else {
                that.yzmSend = true;
                clearInterval(that.yzmTimer);
                that.yzmTimer = null;
                that.phoneForm.code = '';
              }
            }, 1000);
          }

          that.$message.success('请打开钉钉查看随机密码');
          that.phoneNumTip = '';
        } else {
          that.phoneNumTip = res && res.data && res.data.msg;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    loadCaptchaFn: function loadCaptchaFn() {
      var that = this;
      that.captchaLoaded = true;
      var loginData = null; // 弹出式

      initAliyunCaptcha({
        SceneId: '7nua1mgy',
        // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        prefix: '5q8frz',
        // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
        mode: 'popup',
        // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
        element: '#captcha-element',
        // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        button: '#login-button',
        // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
        captchaVerifyCallback: captchaVerifyCallback,
        // 业务请求(带验证码校验)回调函数，无需修改
        onBizResultCallback: onBizResultCallback,
        // 业务请求结果回调函数，无需修改
        getInstance: getInstance,
        // 绑定验证码实例函数，无需修改
        slideStyle: {
          width: 360,
          height: 40
        },
        // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
        language: 'cn' // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）

      }); // 绑定验证码实例函数。该函数为固定写法，无需修改

      function getInstance(instance) {
        that.captcha = instance;
      } // 业务请求(带验证码校验)回调函数

      /**
        * @name captchaVerifyCallback
        * @function
        * 请求参数：由验证码脚本回调的验证参数，不需要做任何处理，直接传给服务端即可
        * @params {string} captchaVerifyParam
        * 返回参数：字段名固定，captchaResult为必选；如无业务验证场景时，bizResult为可选
        * @returns {{captchaResult: boolean, bizResult?: boolean|undefined}}
        */


      function captchaVerifyCallback(_x2) {
        return _captchaVerifyCallback.apply(this, arguments);
      } // （验证码通过后）业务请求验证结果回调函数


      function _captchaVerifyCallback() {
        _captchaVerifyCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(captchaVerifyParam) {
          var result, captchaVerifyResult, verifyResult;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!that.loading) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt("return", {
                    captchaResult: true // 不出现验证码

                  });

                case 2:
                  that.loading = true; // 1.向后端发起业务请求，获取验证码验证结果和业务结果

                  result = {};
                  _context2.prev = 4;
                  _context2.next = 7;
                  return captchaVerifyAsync({
                    captchaVerifyParam: captchaVerifyParam,
                    login_token: that.loginToken,
                    password: that.phoneForm.code
                  });

                case 7:
                  _context2.t0 = _context2.sent;

                  if (_context2.t0) {
                    _context2.next = 10;
                    break;
                  }

                  _context2.t0 = {};

                case 10:
                  result = _context2.t0;
                  _context2.next = 16;
                  break;

                case 13:
                  _context2.prev = 13;
                  _context2.t1 = _context2["catch"](4);
                  console.log('接口报错：', _context2.t1);

                case 16:
                  console.log('验证result:', result);

                  if (result.code === 200) {
                    loginData = result.data;
                    captchaVerifyResult = true;
                  } else if (result.code === 301) {
                    loginData = null;
                    captchaVerifyResult = false;
                  } else {
                    loginData = null;
                    captchaVerifyResult = true;
                  } // 2.构造标准返回参数


                  verifyResult = {
                    captchaResult: captchaVerifyResult // 验证码验证是否通过，boolean类型，必选
                    // bizResult // 从result获取您的业务验证结果 // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空

                  };
                  that.loading = false;
                  return _context2.abrupt("return", verifyResult);

                case 21:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[4, 13]]);
        }));
        return _captchaVerifyCallback.apply(this, arguments);
      }

      function onBizResultCallback(bizResult) {
        console.log('业务请求回调', bizResult);

        if (bizResult === true) {
          loginData && that.handleLoginAfter(loginData);
        } else {
          console.log('业务验证不通过！');
        }
      }
    },
    destroyCaptchaFn: function destroyCaptchaFn() {
      this.captcha && this.captcha.destroyCaptcha && this.captcha.destroyCaptcha();
    },
    // 点击登录按钮
    handleLogin: function handleLogin() {
      var _this2 = this;

      if (this.loading) return;
      if (!this.phoneReg.test(this.phoneForm.phoneNum.trim())) return;
      this.loading = true;
      this.$store.dispatch('login', {
        login_token: this.loginToken,
        password: this.phoneForm.code
      }).then(function () {
        if (_this2.$route.query.originUrl) {
          window.location.href = _this2.$route.query.originUrl;
        } else {
          localStorage.setItem('loginPhoneNum', _this2.phoneForm.phoneNum.trim());

          _this2.$router.push({
            path: '/workindex'
          });
        }

        _this2.afterLogin();
      }).catch(function (e) {
        _this2.afterLogin();
      });
    },
    handleLoginAfter: function handleLoginAfter(res) {
      var _this3 = this;

      this.$store.dispatch('loginInfo', res).then(function () {
        if (_this3.$route.query.originUrl) {
          window.location.href = _this3.$route.query.originUrl;
        } else {
          localStorage.setItem('loginPhoneNum', _this3.phoneForm.phoneNum.trim());

          _this3.$router.push({
            path: '/workindex'
          });
        }

        _this3.afterLogin();
      });
    },
    afterLogin: function afterLogin() {
      var that = this;
      that.loading = false;
      that.yzmSend = true;
      clearInterval(that.yzmTimer);
      that.yzmTimer = null;
      that.phoneForm.code = '';
    }
  }
};